import { useLayoutEffect } from "react";

// index.css sizes the banner and subtracts it from the page height while this attribute is on <html>.
export const SUPPORT_BANNER_ATTR = "data-support-banner";

interface SupportBannerProps {
  companyName: string;
  language: any;
  /** False while there is no home company to go back to. */
  canGoBack: boolean;
  onBack: () => void;
}

/** Shown on every page while InnovX staff are inside a customer company with their support role. */
const SupportBanner = ({ companyName, language, canGoBack, onBack }: SupportBannerProps) => {
  const t = (key: string) => language?.[key] ?? key;

  useLayoutEffect(() => {
    const root = document.documentElement;
    root.setAttribute(SUPPORT_BANNER_ATTR, "");
    return () => root.removeAttribute(SUPPORT_BANNER_ATTR);
  }, []);

  const name = companyName || t("Company");
  const template = t("InnovX support: acting in {company}");
  const [before, after] = template.includes("{company}") ? template.split("{company}") : [`${template} `, ""];

  return (
    <div role="region" aria-label={t("InnovX support")} className="finex-support-banner">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" style={{ flexShrink: 0 }}>
        <path d="M10 2.5l6 2.5v4.5c0 3.8-2.6 6.9-6 8-3.4-1.1-6-4.2-6-8V5z" />
        <path d="M7.5 10l1.8 1.8 3.4-3.6" />
      </svg>
      <p className="finex-support-banner-text" title={`${before}${name}${after}`}>
        {before}
        <strong style={{ fontWeight: 600 }}>{name}</strong>
        {after}
      </p>
      <button type="button" onClick={onBack} disabled={!canGoBack}>
        <span>{t("Back to InnovX")}</span>
      </button>
    </div>
  );
};

export default SupportBanner;
